var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessToast({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 908"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "color",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#005047"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Done",
    clipPath: "url(#clip0_8300_9329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.81818 12.4456L4.95455 9.81272L4 10.6903L7.81818 14.2008L16 6.67839L15.0455 5.80078L7.81818 12.4456Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8300_9329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessToast);
export default __webpack_public_path__ + "static/media/SuccessToast.a343eebbd1bd7762b87e0029b9b4fec9.svg";
export { ForwardRef as ReactComponent };